import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const LAYOUTS = [
  { key: "1x1", label: "1 × 1", desc: "1 per page (top-half image)" },
  { key: "1x2", label: "1 × 2", desc: "2 per page" },
  { key: "1x3", label: "1 × 3", desc: "3 per page" },
  { key: "2x2", label: "2 × 2", desc: "4 per page" },
  { key: "2x3", label: "2 × 3", desc: "6 per page" },
];

// Renders a mini preview: a rectangle divided into `cols × rows` cells. For 1x1,
// only the top half of the rectangle is filled, the bottom half is blank.
function LayoutPreview({ layoutKey }) {
  const [cols, rows] = layoutKey.split("x").map(Number);
  const isTopHalfOnly = layoutKey === "1x1";
  const cells = [];
  const total = isTopHalfOnly ? 1 : cols * rows;
  const effectiveRows = isTopHalfOnly ? 2 : rows;
  for (let i = 0; i < total; i++) {
    cells.push(
      <div key={i} className="rounded-[2px] border border-blue-500 bg-blue-100/60" />
    );
  }
  return (
    <div
      className="grid h-14 w-10 gap-0.5 rounded-sm border border-zinc-300 bg-white p-1"
      style={{
        gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
        gridTemplateRows: `repeat(${effectiveRows}, minmax(0, 1fr))`,
      }}
    >
      {cells}
    </div>
  );
}

export function GridLayoutPickerDialog({ open, onOpenChange, onPick }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-sm" data-testid="grid-layout-picker-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Choose print layout</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-1 gap-2">
          {LAYOUTS.map((layout) => (
            <button
              type="button"
              key={layout.key}
              onClick={() => {
                onPick(layout.key);
                onOpenChange(false);
              }}
              className="flex items-center gap-4 rounded-sm border border-zinc-300 bg-white px-3 py-2 text-left transition-colors hover:border-blue-600 hover:bg-blue-50"
              data-testid={`grid-layout-option-${layout.key}`}
            >
              <LayoutPreview layoutKey={layout.key} />
              <div className="flex-1">
                <div className="font-heading text-base font-semibold text-zinc-900">{layout.label}</div>
                <div className="text-xs text-zinc-500">{layout.desc}</div>
              </div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
